




























































// import CourseCom from "@/components/Partner/Course/CourseCom";
import { Component, Vue, Watch } from "vue-property-decorator";
import coursecom from "./Course/CourseCom.vue";
import Apply from "./Course/Apply.vue";
@Component({
  components: { coursecom, Apply }
})
// components: {
//   coursecom: CourseCom
// }
// watch: {
//   $route(to, from) {
//     this.activeIndex = this.$route.params.type - 1;
//     this.changeTab(this.$route.params.type - 1);
//   }
// }
export default class Course extends Vue {
  @Watch("$route", { immediate: true })
  onCatalogIdChange() {
    this.activeIndex = parseInt(this.$route.params.type) - 1;
    this.changeTab(this.activeIndex);
  }
  isShow = true;
  pname = "11";
  pdata = "";
  puser = "1";
  phone = { val: "", err: false };
  email = { val: "", err: false };
  casename = "";
  casename2 = "";
  casename3 = "";
  casecon1 = "";
  casecon2 = "";
  casecon3 = "";
  casecon4 = "";
  casecon5 = "";
  casename4 = "";
  casecon6 = "";
  checkList = "";
  radio = "1";
  activeIndex = 0;
  bannerPic =
    "background-image: url(" + require("../../assets/pic_banner_jp.jpg") + ")";
  tabs = [
    // {
    //   title: "面授课程合作",
    //   desc:
    //     "欢迎进入浙江华为讲师资源库，与我们一同基于客户业务场景联合开发专业的培训课程",
    //   bannerTitle: "浙江华为课程合作",
    //   bannerPic:
    //     "background-image: url(" +
    //     require("../../assets/pic_banner_jp.jpg") +
    //     ")",
    //   bannerDesc: "共育精品 实现知识流转与价值发挥"
    // },
    // {
    //   title: "在线课程合作",
    //   desc: "浙江华为“ICT学堂” 推出的，面向合作伙伴的招募和共同成长计划 ",
    //   bannerTitle: "浙江华为课程合作",
    //   bannerPic:
    //     "background-image: url(" +
    //     require("../../assets/pic_banner_jp.jpg") +
    //     ")",
    //   bannerDesc: "共育精品 实现知识流转与价值发挥"
    // },
    // {
    //   title: "课程案例合作",
    //   desc: "以远程/现场形式，进行课程案例的开发合作",
    //   bannerTitle: "浙江华为课程合作",
    //   bannerPic:
    //     "background-image: url(" +
    //     require("../../assets/pic_banner_jp.jpg") +
    //     ")",
    //   bannerDesc: "共育精品 实现知识流转与价值发挥"
    // }
  ];
  // title = "课程案例合作";
  // desc = "以远程/现场形式，进行课程案例的开发合作";
  mounted() {
    // this.activeIndex = this.$route.params.type - 1;
    // this.arrDom = document.getElementsByClassName("TabContent");
    // window.addEventListener("scroll", this.handleScroll);
  }
  destroyed() {
    // window.removeEventListener("scroll", this.handleScroll);
  }

  // 打开提示框
  open() {
    // this.$alert("提交成功", "提交", {
    //   confirmButtonText: "确定",
    //   callback: action => {
    //     // this.$message({
    //     //   type: "info",
    //     //   message: `action: ${action}`
    //     // });
    //     location.reload();
    //   }
    // });
  }
  getMsgFormSon(data) {
    // console.log(that.msgFormSon);
    if (data == 1) {
      this.isShow = false;
      // var timer = setInterval(function() {
      //   // let osTop =
      //   //   document.documentElement.scrollTop || document.body.scrollTop;
      //   // let ispeed = -10;
      //   // document.documentElement.scrollTop = document.body.scrollTop =
      //   //   osTop + ispeed;
      //   // if (osTop <= 600) {
      //   //   clearInterval(timer);
      //   // }
      //
      //   that.handleSelectTab();
      //   clearInterval(timer);
      // }, 100);
    }
  }
  changeTab(index) {
    this.activeIndex = index;
    // this.title = this.tabs[index].title;
    // this.desc = this.tabs[index].desc;
    // this.bannerPic = this.tabs[index].bannerPic;
    // console.log(this.tabs[index].bannerPic);
    this.isShow = true;
    this.radio = index + 1 + "";
  }
  change(index) {
    this.activeIndex = index - 1;
    this.radio = index + -1 + "";
  }
}
